import { graphql } from "~/gql";
import { useMutation, useQuery } from "@apollo/client";

const UPDATE_PROPOSAL_HTML = graphql(/* GraphQL */ `
  mutation UpdateProposalHtml($update: UpdateProposalOutputInput!) {
    updateProposalHtml(update: $update)
  }
`);

export const PROPOSAL_BY_MATTER_ID = graphql(/* GraphQL */ `
  query ProposalByMatterId($matterId: Float!) {
    proposalByMatterId(matterId: $matterId) {
      html
      proposal {
        includeTasks
        includeRatesInProposalOutput
        includeFeeEarnersInProposalOutput
        feeRiskInclude
        feeRiskCappedFeeInclude
        feeRiskValid
        ganttAvailable
        ganttInclude
      }
      outputTemplateId
      outputTemplateName
    }
  }
`);

export const UPDATE_PROPOSAL_OPTIONS = graphql(/* GraphQL */ `
  mutation UpdateProposalOptions($updateOptions: UpdateProposalOptionsInput!) {
    updateProposalOptions(updateOptions: $updateOptions) {
      includeTasks
      includeDiagram
      showFeeEarners
      showRates
    }
  }
`);

export type ProposalOptions = {
  includeTasks?: boolean;
  showFeeEarners?: boolean;
  showRates?: boolean;
  includeDiagram?: boolean;
};

export const useVpdProposalEngine = (matterId: number) => {
  const [updateProposalHtml] = useMutation(UPDATE_PROPOSAL_HTML);

  // Get the server parsed html.
  const {
    loading: isLoading,
    data: initialCompiledContent,
    refetch,
  } = useQuery(PROPOSAL_BY_MATTER_ID, {
    variables: { matterId },
    fetchPolicy: "network-only",
  });

  return {
    initialCompiledContent: initialCompiledContent?.proposalByMatterId,
    isLoading,
    updateProposalHtml,
    refetch,
  };
};
